import ConfirmationDialog from "@/shared/components/domain/confirmation/confirmation-dialog";
import {
  useErrArtefactNotReady,
  useSetErrArtefactNotReadyFromRtk,
} from "@/shared/service-manager/artefact/err-artefact-not-ready";
import { Button } from "@/shared/components/ui/button";
import { ReactElement } from "react";
import { useDeleteBatchMutation } from "@/services/backend/batches/batch/service";
import { Trash } from "lucide-react";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";

interface DeleteBatchButtonProps {
  batchId: string;
}

export default function DeleteBatchButton({
  batchId,
}: DeleteBatchButtonProps): ReactElement {
  const [deleteBatch, { error, reset, isLoading }] = useDeleteBatchMutation();
  const { resetNotReadyError } = useErrArtefactNotReady();
  useSetErrArtefactNotReadyFromRtk(error, () => {
    reset();
  });
  const onConfirm = () => {
    if (isLoading) {
      return;
    }

    resetNotReadyError();
    deleteBatch({
      id: batchId,
    });
  };

  return (
    <>
      <RTKQueryErrorAlert error={error} />
      <ConfirmationDialog
        trigger={
          <Button className="bg-red-600">
            <Trash />
          </Button>
        }
        title="Charge löschen"
        description="Hiermit wird die Charge aus den Stammdaten gelöscht. Die Charge bleibt jedoch bei Prozessen erhalten!"
        onConfirm={onConfirm}
      />
    </>
  );
}
